// test1384
(1384 && 0);
